import {
  Stack,
  StackProps,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CustomButton from '../../../components/MUIComponents/CustomButton';
import { ButtonTypeEnum } from '../../../enums/button-type-enum';
import JobPostSidebarMoreMenu from './JobPostSidebarMoreMenu';
import { useNavigate } from 'react-router-dom';
import { IJobpost } from '../../../interfaces/jobpost.interface';

interface IJobPostSidebarActionsProps {
  jobPost: IJobpost;
  refetchJobpostData: () => void;
}

const JobPostSidebarActions = ({
  jobPost,
  refetchJobpostData,
}: IJobPostSidebarActionsProps) => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('lg'));

  const jobpostId = jobPost.id;

  const navigate = useNavigate();
  return (
    <StyledStack
      direction={{ xs: 'row', lg: 'column' }}
      gap={'12px'}
      p={'21px 16px'}
    >
      <CustomButton
        variantType={ButtonTypeEnum.PRIMARY}
        variant="contained"
        sx={{ width: '100%' }}
        onClick={() => {
          // Scroll to applications section
          const applicationsSection = document.querySelector(
            '[data-section="applications"]'
          );
          if (applicationsSection) {
            applicationsSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }}
      >
        view applications
      </CustomButton>
      {!mobileView && (
        <Stack direction={'row'} gap={'12px'}>
          <CustomButton
            variant="outlined"
            variantType={ButtonTypeEnum.SECONDARY}
            onClick={() => navigate(`/manage-job-post/${jobpostId}`)}
            sx={{ width: '100%' }}
          >
            edit job post
          </CustomButton>
          <JobPostSidebarMoreMenu
            jobPost={jobPost}
            refetchJobpostData={refetchJobpostData}
          />
        </Stack>
      )}
      {mobileView && (
        <JobPostSidebarMoreMenu
          jobPost={jobPost}
          refetchJobpostData={refetchJobpostData}
        />
      )}
    </StyledStack>
  );
};

export default JobPostSidebarActions;

const StyledStack = styled(Stack)<StackProps>(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    position: 'fixed',
    width: '100%',
    bottom: '0',
    backgroundColor: theme.palette.background.white,
    zIndex: '1',
  },
}));
